module.exports = __webpack_public_path__ + "img/about.c5994b43.png";